import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      borderBottom: theme.shape.borderGray70,
    },
    editingActions: {
      position: 'absolute',
      right: theme.spacing(4),
      bottom: theme.spacing(4.5),
    },

    editor: {
      color: COLORS.neutral.blackBlue,
      lineHeight: theme.typography.pxToRem(24),
      fontSize: theme.typography.pxToRem(15),
    },
  }),
  { name: 'CopyInput' }
);
